module.exports = __webpack_public_path__ + "static/media/removed-icon.ef738e78.svg";